<template>
    <div id="app">
        <router-view />
        <div class="env-tag" v-if="envName">{{envName}}正式服-数据谨慎操作</div>
    </div>
</template>
<script>
    export default {
        data() {
            return {

            }
        },
        mounted() {

        },
        created() {

        },
    }
</script>
<style>
    html,
    body {
        height: 100%;
        min-height: 100%;
    }

    #app {
        height: 100%;
    }

    body .el-table th.gutter {
        display: table-cell !important;
    }

    .input-box .el-input__inner {
        text-indent: 20px;
    }

    #Novel_Details .el-cascader__tags {
        display: inline-block !important;
        line-height: 30px !important;
    }

    #app .env-tag {
        position: fixed;
        width: 250px;
        height: 40px;
        color: red;
        bottom: 0px;
        right: 0px;
        font-size: 20px;
        text-align: center;
        line-height: 40px;
        z-index: 99;
        background: rgba(0, 0, 0, 0.8);
    }
</style>